{
  "name": "@bigcommerce/catalyst",
  "version": "1.1.0",
  "type": "module",
  "repository": {
    "type": "git",
    "url": "https://github.com/bigcommerce/catalyst",
    "directory": "packages/catalyst"
  },
  "bin": {
    "catalyst": "dist/cli.js"
  },
  "files": [
    "dist",
    "templates"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "typecheck": "tsc --noEmit",
    "lint": "eslint . --max-warnings 0",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "build": "tsup"
  },
  "engines": {
    "node": "^20.0.0 || ^22.0.0 || ^24.0.0"
  },
  "dependencies": {
    "@commander-js/extra-typings": "^14.0.0",
    "@inquirer/prompts": "^7.5.3",
    "@segment/analytics-node": "^2.2.1",
    "adm-zip": "^0.5.16",
    "commander": "^14.0.0",
    "conf": "^13.1.0",
    "consola": "^3.4.2",
    "cross-spawn": "^7.0.6",
    "dotenv": "^16.5.0",
    "execa": "^9.6.0",
    "fs-extra": "^11.3.0",
    "lodash.kebabcase": "^4.1.1",
    "nypm": "^0.5.4",
    "open": "^10.1.0",
    "semver": "^7.7.4",
    "std-env": "^3.9.0",
    "tar": "^7.5.7",
    "yocto-spinner": "^1.0.0",
    "zod": "^4.0.5"
  },
  "devDependencies": {
    "@bigcommerce/eslint-config": "^2.11.0",
    "@bigcommerce/eslint-config-catalyst": "workspace:^",
    "@types/adm-zip": "^0.5.7",
    "@types/cross-spawn": "^6.0.6",
    "@types/fs-extra": "^11.0.4",
    "@types/lodash.kebabcase": "^4.1.9",
    "@types/node": "^22.15.30",
    "@types/semver": "^7.7.0",
    "@vitest/coverage-v8": "^3.2.4",
    "@vitest/ui": "^3.2.4",
    "eslint": "^8.57.1",
    "msw": "^2.9.0",
    "prettier": "^3.6.2",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@opennextjs/cloudflare": "1.17.3"
  }
}
